import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import StateSummary from '../StateSummary/StateSummary';
import './Tooltip.scss';

export const MAP_TOOLTIP_ID = 'state-tooltip';

export const getStateTooltipHtml = (stateData) => (
  ReactDOMServer.renderToStaticMarkup(<StateSummary stateData={stateData} />)
);

const Tooltip = () => (
  <ReactTooltip id={MAP_TOOLTIP_ID} className="map-tooltip" variant="light" arrowColor="black" />
);

export default Tooltip;
